
import * as React from "react";
import { makeStyles } from "@fluentui/react-components";
import { withStyles } from "./withStyles";
import * as CSS from "csstype";
import { SignInOrOutButton } from "./SignInOrOutButton";
import { IMsalContext, MsalContext } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import { slThemeLight } from "../slTheme";
import logo from '../smoker.jpg';

export interface SiteHeaderProps
{
    styles: Record<string, string>;
}

export interface SiteHeaderState
{
}

/*
            #tblNav
            {
                font-family: "SegoUI", "yahoma", "arial";
                text-transform: uppercase;
            }
            #tblNav td
            {
                padding-left: 12px;
                padding-right: 12px;
            }

                        div.mainPanel {
                width: 7.5in;
            }

            div.Header {
                background: black;
                height: 1.5in;
                position: relative;
            }

            div.Header h1 {
                position: absolute;
                bottom: 0;
                left: 0;
                color: white;
                font-size: 38pt;
                font-family: 'Calibri Light', 'Tahoma', 'Arial', sans-serif;
                font-weight: normal;
                margin: 0pt;
            }

            #divResult {
                position: absolute;
                right: 0;
                width: 50%;
                background: lightgray;
                overflow: auto;
                font-family: "Consolas";
                font-size: 10pt;
                height: 100%;
            }
*/
const useStyles = makeStyles(
    {
        headerBlock: {
            background: "black",
            height: "1.25in",
            padding: '12pt',
            position: 'relative',
            color: 'white'
        },
        headerH1: {
            color: 'white',
            fontSize: slThemeLight.fontSizeHero800,
            lineHeight: slThemeLight.lineHeightHero800,
            fontFamily: 'Calibri Light, Tahoma, Arial, sans-serif',
            fontWeight: 'normal',
            textTransform: 'lowercase',
            position: 'absolute',
            bottom: 0,
        },
        logo:
        {
            width: '1.75in',
            float: 'right'
        }
    });

export class SiteHeaderWithoutStyles extends React.Component<SiteHeaderProps, SiteHeaderState>
{
    context!: IMsalContext;
    static contextType = MsalContext;

    render()
    {
        const loginInProgress = this.context.inProgress === InteractionStatus.Startup || this.context.inProgress === InteractionStatus.HandleRedirect;

        return (
            <div className={this.props.styles.headerBlock}>
                <img className={this.props.styles.logo} src={logo} alt="logo"/>
                <div>
                    <SignInOrOutButton isAuthenticated={this.context.accounts.length > 0} isInProgress={loginInProgress}/>
                </div>
                <div className={this.props.styles.headerH1}>
                    hot smoking love
                </div>
            </div>
        );
    }
}

export const SiteHeader = withStyles(useStyles, SiteHeaderWithoutStyles);